import {combineReducers} from 'redux';

import config from './config';
import validationInfo from './validationInfo';
import ToastService from '-/services/ToastService';
import BuyerInfoService from '-/services/BuyerInfoService';
import NavigationService from '-/services/NavigationService';
import EmploymentInfoService from '-/services/EmploymentInfoService';
import VehicleInfoService from '-/services/VehicleInfoService';
import AdditionalIncomeService from '-/services/AdditionalIncomeService';
import UIService from '-/services/UIService';
import ApiService from '-/services/ApiService';
import CallbackService from '-/services/CallbackService';
import CreditorService from '-/services/CreditorService';
import StipsService from '-/services/StipsService';
import DialogService from '-/services/DialogService';
import DealInfoService from '-/services/DealInfoService';
import DocumentService from '../services/DocumentService';

export default combineReducers({
    config,
    validationInfo,
    [ToastService.getReducerName()]: ToastService.getReducer(),
    [BuyerInfoService.getReducerName()]: BuyerInfoService.getReducer(),
    [NavigationService.getReducerName()]: NavigationService.getReducer(),
    [EmploymentInfoService.getReducerName()]: EmploymentInfoService.getReducer(),
    [VehicleInfoService.getReducerName()]: VehicleInfoService.getReducer(),
    [AdditionalIncomeService.getReducerName()]: AdditionalIncomeService.getReducer(),
    [UIService.getReducerName()]: UIService.getReducer(),
    [ApiService.getReducerName()]: ApiService.getReducer(),
    [CallbackService.getReducerName()]: CallbackService.getReducer(),
    [CreditorService.getReducerName()]: CreditorService.getReducer(),
    [StipsService.getReducerName()]: StipsService.getReducer(),
    [DialogService.getReducerName()]: DialogService.getReducer(),
    [DealInfoService.getReducerName()]: DealInfoService.getReducer(),
    [DocumentService.getReducerName()]: DocumentService.getReducer()
});
